import { useState, useEffect } from "react";
import * as React from 'react';
import styles from "./paymentForm.module.css";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import valid from 'card-validator';
import Loader from '../loader';
// import useAuth from "../../azureLogin/useAuth";
import { protectedResources } from "../../azureLogin/msalPayerConfig";
import { useImplicitAuth } from "../../azureLogin/useImplicitAuth";
import { orderIdForTppValidation } from "./tppOrderId";

const MySwal = withReactContent(Swal);

export const PayerForm = ({orders , handlePaySubmitClick,handlePayCancelClick ,email , toBePaid, onBlocked }) => {
  const [message, setMessage] = useState("");
  const [messageClass, setMessageClass] = useState(styles.messageok);
  const [cardNumber, setCardNumber] = useState('');
  const [cardType, setCardType] = useState(null);
  const [isCardValid, setIsCardValid] = useState(false);
  const [expiryDate, setExpiryDate] = useState('');
  const [cvv, setCvv] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isAmountZero, setIsAmountZero] = useState(false);
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [country, setCountry] = useState('');
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [lastName, setLastName] = useState('');
  const [suffix, setSuffix] = useState('');
  const [isRefundPolicyChecked, setIsRefundPolicyChecked] = useState(false);
  const [billingSameAsMailing, setBillingSameAsMailing] = useState(false);
  const [declineErrorMsg, setDeclineErrorMsg] = useState('');
  const [errorMessageClass, setErrorMessageClass] = useState('');
  const [cardNumberError, setCardNumberError] = useState('');
  const [expiryDateError, setExpiryDateError] = useState('');
  const [cvvError, setCvvError] = useState('');
  const [countryError, setCountryError] = useState('');
  const [countries, setCountries] = useState([]);
  const [updatedOrders, setUpdatedOrders] = useState([]);
  const [streetAddress, setStreetAddress] = useState('');
  const [streetAddressError, setStreetAddressError] = useState('');
  const [cityError, setCityError] = useState('');
  const [stateError, setStateError] = useState('');
  const [postalCodeError, setPostalCodeError] = useState('');
  const [billingStreetAddress, setBillingStreetAddress] = useState('');
  const [billingCity, setBillingCity] = useState('');
  const [billingState, setBillingState] = useState('');
  const [billingPostalCode, setBillingPostalCode] = useState('');
  const [billingCountry, setBillingCountry] = useState('');
  const [billingStreetAddressError, setBillingStreetAddressError] = useState('');
  const [billingCityError, setBillingCityError] = useState('');
  const [billingStateError, setBillingStateError] = useState('');
  const [billingPostalCodeError, setBillingPostalCodeError] = useState('');
  const [billingCountryError, setBillingCountryError] = useState('');
  // const { fetchData: fetchAuthData, postData } = useAuth();
  const { fetchOrdersData: fetchImplicitData, postData, fetchData } = useImplicitAuth();
 

 // Create a copy to avoid mutating the original array
 useEffect(() => {
  setUpdatedOrders(orders);
}, [orders]);

  useEffect(() => {
    // This will trigger a re-render when the message state changes
    console.log("Message updated:", message);
  }, [message]);

  useEffect(() => {
    console.log("decline error message", declineErrorMsg);
  }, [declineErrorMsg]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetchImplicitData(protectedResources.apiPayer.queries.countries,{
          headers: {
            'accept': 'application/json'
          }
          });
        if (response.status!==200) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        console.log("~ PayerForm.js: line:73 ~ Countries fetched: ", response.data); 
        setCountries(response.data);
      } catch (error) {
        console.error('Error fetching countries:', error);
        setCountryError('Failed to load countries');
      }
    };

    fetchCountries();
  }, []);


  const validateName = (name, field, required = false) => {
    if (required && name.trim() === '') {
      return field === 'lastName' ? 'Please fill the last name' : '';
    }
    return '';
  };

  const resetForm = () => {
    setCardNumber('');
    setCardType(null);
    setIsCardValid(false);
    setExpiryDate('');
    setCvv('');
    setCity('');
    setStreetAddress('');
    setState('');
    setPostalCode('');
    setCountry('');
    setFirstName('');
    setMiddleName('');
    setLastName('');
    setSuffix('');
    setBillingSameAsMailing(false);
    setBillingStreetAddress('');
    setBillingCity('');
    setBillingState('');
    setBillingPostalCode('');
    setBillingCountry('');
    setBillingStreetAddressError('');
    setBillingCityError('');
    setBillingStateError('');
    setBillingPostalCodeError('');
    setBillingCountryError('');
    setErrors({});
    setMessage('');
    setMessageClass(styles.messageok);
    setIsRefundPolicyChecked(false);
    document.getElementById('form').reset();
  };

  useEffect(() => {
    const total = orders.reduce((sum, order) => sum + parseChargeAmount(order), 0);
    setIsAmountZero(total === 0);
    if (total === 0) {
      setMessage("No Due Amount");
      setMessageClass(styles.messageok);
    }
  }, [orders]);

  const TIMEOUT_ERROR_MESSAGE = "We did not receive a response from the credit card payment processing system. Please try again later and contact TruMerit if the problem persists.";
  const PAYMENT_FAILED_MESSAGE = "We are unable to process your payment. Please try again later, use another card, or contact TruMerit for assistance.";
  const PAYMENT_DECLINED_MESSAGES = {
    2: "Invalid Credit Card Type. TruMerit only accepts Visa, Mastercard, and Discover Credit Cards. Please enter the card number from one of these types.",
    12: "Your bank has declined approval of this payment. Please check the credit card number, expiration date, and contact information to make sure they were entered correctly. If this does not resolve the problem, please contact your card’s customer service department for assistance.",
    13: "This payment cannot be approved electronically but can be approved with a verbal authorization. Contact your merchant bank to obtain an authorization and instructions to complete the payment.",
    23: "Your credit card number is invalid. Check credit card number and re-submit.",
    24: "The expiration date is not valid. Please correct and resubmit.",
    112: "The address you have entered does not match the address associated with your credit card. Please correct the address and resubmit.",
    114: "The CVV Code you have entered is not valid. Please correct and resubmit the payment."
  };
 
  function customError(responseDetails){
    const { success,message,statusCode,result } = responseDetails;

    // Default modal values
    let modalTitle = "";
    let modalMessage = "";

    if (success) {
      modalTitle = "Payment Successful";
      modalMessage = "";  
    } else {
      // Error handling based on statusCode and message.result
      switch (statusCode) {
        case 408: // Timeout errors
          modalTitle = "Payment Failed";
          if ([104, 109, 115, 150].includes(result)) {
            modalMessage = TIMEOUT_ERROR_MESSAGE;
          }else{modalMessage = PAYMENT_FAILED_MESSAGE;}
          break;

        case 409: // Payment declined errors
          modalTitle = "Payment Declined";
          if (result !== undefined && PAYMENT_DECLINED_MESSAGES[result]) {
            modalMessage = PAYMENT_DECLINED_MESSAGES[result];
          }else{modalMessage = PAYMENT_FAILED_MESSAGE;}
          break;

        case 422: // Validation error
          modalTitle = "Data Error";
          modalMessage = message + "; Please fix the error and resubmit your request.";
          break;

        case 500: // System error
          modalTitle = "Payment Failed";
          modalMessage = PAYMENT_FAILED_MESSAGE;
          break;

        default: // Unknown error
          modalTitle = "Payment Failed";
          modalMessage = PAYMENT_FAILED_MESSAGE;
          break;
      }
    }

      return modalMessage;
 
  };


  const handleCardNumberChange = (e) => {
    const input = e.target.value.replace(/\D/g, '');
    setCardNumber(input);

    // Clear the card number error if input is not empty
    if (input) {
      setCardNumberError('');
    }

    const numberValidation = valid.number(input);

    if (numberValidation.card) {
      const { type } = numberValidation.card;
      setCardType(type);
      setIsCardValid(numberValidation.isValid);

      // Check if the card type is valid
      const validCardTypes = ['visa', 'mastercard', 'discover'];
      if (!validCardTypes.includes(type)) {
        setErrors(prev => ({
          ...prev,
          cardNumber: 'Invalid tender type: TruMerit only accepts Visa, Mastercard, or Discover Credit Cards. Please enter a valid Visa, Mastercard, or Discover Credit Card number.'
        }));
      } else {
        setErrors(prev => ({
          ...prev,
          cardNumber: input.length !== 16 ? 'Card number must be 16 digits' : ''
        }));
      }
    } else {
      setCardType(null);
      setIsCardValid(false);
      setErrors(prev => ({
        ...prev,
        cardNumber: ''
      }));
    }
  };

  const handleExpiryDateChange = (e) => {
    let input = e.target.value.replace(/\D/g, '');
    let formattedInput = input;
    if (input.length > 2) {
      input = input.slice(0, 6);
      formattedInput = input.slice(0, 2) + '/' + input.slice(2);
    } else if (input.length === 2) {
      formattedInput = input + '/';
    }
    setExpiryDate(formattedInput);
    let error = '';
    if (input.length === 6) {
      const month = parseInt(input.slice(0, 2));
      const year = parseInt(input.slice(2, 6));
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      if (month > 12 || month === 0) {
        error = 'Invalid month';
      } else if (year < currentYear || (year === currentYear && month < currentMonth)) {
        error = 'Expiry date must be in the future';
      }
    }
    setErrors(prev => ({ ...prev, expiryDate: error }));
    if (expiryDate) {
      setExpiryDateError('');
    }
  };

  const handleCvvChange = (e) => {
    const input = e.target.value.replace(/\D/g, '');
    setCvv(input);
    if (input) {
      setCvvError('');
    }
  };

  const formatCardNumber = (number) => {
    const groups = number.match(/\d{1,4}/g) || [];
    return groups.join(' ');
  };

  const handleCityChange = (e) => {
    const input = e.target.value;
    setCity(input);
    if (input.trim() !== '') {
      setCityError('');
    }
  };

  function parseChargeAmount(order) {
    const fromDisplayedAmount = parseFloat(String(order?.lineBalance ?? '').replace(/[$,]/g, ''));
    if (Number.isFinite(fromDisplayedAmount) && fromDisplayedAmount > 0) {
      return fromDisplayedAmount;
    }
    if (typeof order?.amountDue === 'number' && order.amountDue > 0) {
      return order.amountDue;
    }
    return Number.isFinite(fromDisplayedAmount) ? fromDisplayedAmount : 0;
  }

  function getStateProvincesForCountry(paymentCountry) {
    const countryItem = countries.find(c => c.countryName === paymentCountry);
    const provinces = countryItem?.stateProvinces || [];
    return [...provinces].sort((a, b) => {
      const labelA = getStateOptionLabel(paymentCountry, a);
      const labelB = getStateOptionLabel(paymentCountry, b);
      return String(labelA).localeCompare(String(labelB), undefined, { sensitivity: 'base' });
    });
  }

  function getStateOptionValue(stateItem) {
    return stateItem.abbreviation || stateItem.name;
  }

  function getStateProvincesId(paymentCountry, stateValue) {
    if (!stateValue) {
      return null;
    }
    const match = getStateProvincesForCountry(paymentCountry).find(
      s => getStateOptionValue(s) === stateValue || s.name === stateValue
    );
    return match?.stateProvincesId ?? null;
  }

  function getStateOptionLabel(paymentCountry, stateItem) {
    if (paymentCountry === 'United States') {
      return stateItem.abbreviation || stateItem.name;
    }
    return stateItem.name;
  }

  function renderStateProvinceField({
    name,
    value,
    onChange,
    paymentCountry,
    error,
    keyPrefix,
  }) {
    const provinces = getStateProvincesForCountry(paymentCountry);

    if (paymentCountry && provinces.length > 0) {
      return (
        <>
          <select
            name={name}
            className={styles.input}
            value={value}
            onChange={onChange}
            disabled={!paymentCountry}
          >
            <option value="">Select a State/Province</option>
            {provinces.map((stateItem) => (
              <option
                key={`${keyPrefix}-${stateItem.abbreviation || stateItem.name}`}
                value={getStateOptionValue(stateItem)}
              >
                {getStateOptionLabel(paymentCountry, stateItem)}
              </option>
            ))}
          </select>
          {error && <p className="small text-danger">{error}</p>}
        </>
      );
    }

    return (
      <>
        <input
          name={name}
          type="text"
          placeholder="State/Province"
          className={styles.input}
          value={value}
          onChange={onChange}
          maxLength="30"
          disabled={!paymentCountry}
        />
        {error && <p className="small text-danger">{error}</p>}
      </>
    );
  }

  function validate_stateProvince(paymentCountry, stateProvince) {
    const provinces = getStateProvincesForCountry(paymentCountry);
    if (provinces.length > 0) {
      if (!stateProvince || stateProvince.trim() === '') {
        return "Please select the State or Province";
      }
      const isValid = provinces.some(
        s => getStateOptionValue(s) === stateProvince || s.name === stateProvince
      );
      if (!isValid) {
        return "Invalid State or Province.";
      }
      return;
    }

    if (paymentCountry === 'United States') {
      if (stateProvince === '')
        return "Please enter the State or Province";
      if (stateProvince?.length != 2)
        return "Enter a valid 2-letter US state code (e.g., CA, NY).";
    }
    else if (stateProvince?.length > 30) {
      return "State or Province may not exceed 30 characters";
    }
  }

  const validateStateAndPostalCode = (_paymentCountry, _stateProvince, _postalCode, isBilling = false) => {
    let isValid = true;
    const setStateErr = isBilling ? setBillingStateError : setStateError;
    const setPostalErr = isBilling ? setBillingPostalCodeError : setPostalCodeError;

    let errorMessage = validate_stateProvince(_paymentCountry, _stateProvince);
    if (errorMessage?.length > 0) {
      setStateErr(errorMessage);
      isValid = false;
    } else {
      setStateErr("");
    }

    if (_paymentCountry === 'United States') {
      const regex = /^\d{5}(-\d{4})?$/;

      if (_postalCode.trim() === "") {
        setPostalErr("Please enter your Postal Code");
        isValid = false;
      } else if (!regex.test(_postalCode)) {
        setPostalErr("Use postal code format XXXXX or XXXXX-XXXX.");
        isValid = false;
      } else {
        setPostalErr("");
      }
    } else {
      setPostalErr("");
    }

    return isValid;
  };

  const handleStateChange = (e) => {
    const input = e.target.value;
    const provinces = getStateProvincesForCountry(country);
    const formattedInput =
      provinces.length === 0 && country === 'United States'
        ? input.trim().toUpperCase()
        : input;
    setState(formattedInput);
    validateStateAndPostalCode(country, formattedInput, postalCode);
  };

  const handlePostalCodeChange = (e) => {
    let input = e.target.value;
    let formattedInput = input.replace(/\D/g, '');

    if (country === 'United States') {
      if (formattedInput.length <= 5) {
        formattedInput = formattedInput.slice(0, 5);
      } else {
        const firstPart = formattedInput.slice(0, 5);
        const secondPart = formattedInput.slice(5, 9);
        formattedInput = `${firstPart}-${secondPart}`;
      }


    } else {
      formattedInput = input.replace(/[^A-Za-z0-9-\s]/g, '');
    }

    setPostalCode(formattedInput);

    validateStateAndPostalCode(country,state,formattedInput);
  };


  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value.trim();
    setCountry(selectedCountry);
    setState('');
    setStateError('');

    if (!selectedCountry || selectedCountry.length < 1) {
      setCountryError("Please select your country.");
    } else {
      setCountryError("");
    }

    validateStateAndPostalCode(selectedCountry, '', postalCode);
  };

  const handleBillingStateChange = (e) => {
    const input = e.target.value;
    const provinces = getStateProvincesForCountry(billingCountry);
    const formattedInput =
      provinces.length === 0 && billingCountry === 'United States'
        ? input.trim().toUpperCase()
        : input;
    setBillingState(formattedInput);
    validateStateAndPostalCode(billingCountry, formattedInput, billingPostalCode, true);
  };

  const handleBillingPostalCodeChange = (e) => {
    let input = e.target.value;
    let formattedInput = input.replace(/\D/g, '');

    if (billingCountry === 'United States') {
      if (formattedInput.length <= 5) {
        formattedInput = formattedInput.slice(0, 5);
      } else {
        const firstPart = formattedInput.slice(0, 5);
        const secondPart = formattedInput.slice(5, 9);
        formattedInput = `${firstPart}-${secondPart}`;
      }
    } else {
      formattedInput = input.replace(/[^A-Za-z0-9-\s]/g, '');
    }

    setBillingPostalCode(formattedInput);
    validateStateAndPostalCode(billingCountry, billingState, formattedInput, true);
  };

  const handleBillingCountryChange = (e) => {
    const selectedCountry = e.target.value.trim();
    setBillingCountry(selectedCountry);
    setBillingState('');
    setBillingStateError('');

    if (!selectedCountry || selectedCountry.length < 1) {
      setBillingCountryError("Please select your country.");
    } else {
      setBillingCountryError("");
    }

    validateStateAndPostalCode(selectedCountry, '', billingPostalCode, true);
  };

  const handleFirstNameChange = (e) => {
    const input = e.target.value;
    setFirstName(input);
    setErrors(prev => ({
      ...prev,
      firstName: validateName(input, 'firstName'),
    }));
  };

  const handleMiddleNameChange = (e) => {
    setMiddleName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    const input = e.target.value;
    setLastName(input);
    setErrors(prev => ({
      ...prev,
      lastName: validateName(input, 'lastName', true),
    }));
  };

  const handleSuffixChange = (e) => {
    setSuffix(e.target.value);
  };

  const handleStreetAddressChange = (e) => {
    const input = e.target.value;
    setStreetAddress(input);
    if (input.trim() !== '') {
      setStreetAddressError('');
    }
  };

  const handleBillingStreetAddressChange = (e) => {
    const input = e.target.value;
    setBillingStreetAddress(input);
    if (input.trim() !== '') {
      setBillingStreetAddressError('');
    }
  };

  const handleBillingCityChange = (e) => {
    const input = e.target.value;
    setBillingCity(input);
    if (input.trim() !== '') {
      setBillingCityError('');
    }
  };

  const handleBillingSameAsMailingChange = () => {
    const nextValue = !billingSameAsMailing;
    setBillingSameAsMailing(nextValue);
    if (nextValue) {
      setStreetAddress('');
      setCity('');
      setState('');
      setPostalCode('');
      setCountry('');
      setStreetAddressError('');
      setCityError('');
      setStateError('');
      setPostalCodeError('');
      setCountryError('');
    }
  };
  
  const handleCancel = (e) => {
    handlePayCancelClick();
  };

  const updateOrderWithResponse = (response, order, index, updatedOrders) => {
      const responseData  = response.data;
  
    if (![200, 408, 409].includes(response.status)) {
      const { statusCode, details } = responseData.error;
      const errorDetails = details
        ?.map((e) => `${e.path}: ${e.message}`)
        .join(', ') || 'Unknown error occurred.';
  
      const errorMessage = customError({
        success: false,
        message: errorDetails,
        statusCode,
      });
  
      updatedOrders[index] = {
        ...order,
        status: 'Failed',
        message: errorMessage,
        statusCode,
      };
    } else {
      const { result, pnref, bal, amt } = responseData.result==0?responseData:responseData.message;
      const success = result === 0;
  
      const successMessage = customError({
        success,
        result,
        statusCode: response.status,
      });
  
      updatedOrders[index] = {
        ...order,
        status: success ? 'Success' : 'Failed',
        transactionId: pnref,
        remainingBalance: bal,
        amountPaid: amt,
        statusCode: response.status,
        message: successMessage,
      };
    }
  };

  const submitHandler = async (e) => {
    let isValid = true;
    e.preventDefault();
    setMessage("");

    if (!cardNumber || (isCardValid && cardNumber.length !== 16)) {
      const validCardTypes = ['visa', 'mastercard', 'discover'];
      if (validCardTypes.includes(cardType) && cardNumber.length !== 16) {
        setCardNumberError('Card number must be 16 digits.');
        isValid = false;
      } else if (!cardNumber) {
        setCardNumberError('Please enter your Card Number');
        isValid = false;
      }
    } else if (!isCardValid) {
      setCardNumberError('Card number is not valid.');
      isValid = false;
    } else {
      setCardNumberError('');
    }

    if (!expiryDate) {
      setExpiryDateError('Please enter your Expiry Date.');
      isValid = false;
    } else if (expiryDate.length < 7) {
      setExpiryDateError('Expiry date must be in MM/YYYY format');
      isValid = false;
    }else if (errors.expiryDate) { 
      isValid = false;
    } else {
      setExpiryDateError('');
    }

    if (!cvv) {
      setCvvError('Please enter your CVV.');
      isValid = false;
    } else if (cvv.length !== 3) {
      setCvvError('CVV must be 3 digits');
      isValid = false;
    } else {
      setCvvError('');
    }

    if (!billingCity || billingCity.trim() === '') {
      setBillingCityError('Please enter your City.');
      isValid = false;
    }

    if (!validateStateAndPostalCode(billingCountry, billingState, billingPostalCode, true)) {
      isValid = false;
    }

    if (!billingStreetAddress || billingStreetAddress.trim() === '') {
      setBillingStreetAddressError('Please enter your Street Address.');
      isValid = false;
    }

    if (!billingCountry.trim() || billingCountry.length < 1) {
      setBillingCountryError("Please select your Country.");
      isValid = false;
    } else {
      setBillingCountryError("");
    }

    if (!billingSameAsMailing) {
      if (!city || city.trim() === '') {
        setCityError('Please enter your City.');
        isValid = false;
      }

      if (!validateStateAndPostalCode(country, state, postalCode)) {
        isValid = false;
      }

      if (!streetAddress || streetAddress.trim() === '') {
        setStreetAddressError('Please enter your Street Address.');
        isValid = false;
      }

      if (!country.trim() || country.length < 1) {
        setCountryError("Please select your Country.");
        isValid = false;
      } else {
        setCountryError("");
      }
    }

    if (errors?.firstName) {
      isValid = false;
    }

    if (!lastName.trim()) {
      setErrors(prev => ({
        ...prev,
        lastName: 'Please enter your Last Name.',
      }));
      isValid = false;
    } else if (errors?.lastName) {
      isValid = false;
    }

    if (!isRefundPolicyChecked) {
      setMessage("Acknowledgement of No Refund statement required.");
      setMessageClass(styles.messageerror);
      isValid = false;
    }
   

    if (!isValid) {
      return;
    }

    setIsLoading(true);

    const form = e.target;
    const formData = new FormData(form);
    const formObj = Object.fromEntries(formData.entries());
    formObj.creditCardNbr = formObj.creditCardNbr.replace(/\s/g, '');
    formObj.expirationDate = `${formObj.expirationDate.slice(3)}-${formObj.expirationDate.slice(0, 2)}-01`;

    const firstOrder = updatedOrders[0] || orders[0];
    const resolveStateProvinceName = (countryName, stateValue) => {
      const match = getStateProvincesForCountry(countryName).find(
        s => getStateOptionValue(s) === stateValue || s.name === stateValue
      );
      return match?.name || stateValue || '';
    };
    const stateProvinceForValidation = resolveStateProvinceName(
      formObj.billingCountry || '',
      formObj.billingStateProvince || ''
    );
    const stateProvincesIdForValidation = getStateProvincesId(
      formObj.billingCountry || '',
      formObj.billingStateProvince || ''
    );

    const orderHeadersId = orderIdForTppValidation(firstOrder);
    const tppValidationPayload = {
      email: email || '',
      firstName: formObj.firstName || '',
      middleName: formObj.middleName || '',
      lastName: formObj.lastName || '',
      Suffix: formObj.suffix || '',
      ...(orderHeadersId != null && { order_headers_ID: orderHeadersId }),
      street_Address1: formObj.billingStreetAddress1 || '',
      Country: formObj.billingCountry || '',
      billing_street_Address1: formObj.billingStreetAddress1 || '',
      billing_Country: formObj.billingCountry || '',
      state_province: stateProvinceForValidation,
      billing_state_province: stateProvinceForValidation,
      ...(stateProvincesIdForValidation != null && {
        state_provinces_id: Number(stateProvincesIdForValidation),
        billing_state_provinces_id: Number(stateProvincesIdForValidation),
      }),
      ...(!billingSameAsMailing && {
        mailing_street_Address1: formObj.streetAddress1 || '',
        mailing_Country: formObj.country || '',
        mailing_city: formObj.city || '',
        mailing_state_province: resolveStateProvinceName(
          formObj.country || '',
          formObj.stateProvince || ''
        ),
        mailing_postalCode: formObj.postalCode || '',
      }),
    };

    try {
      const tppValidationResponse = await fetchData('/comply/tppvalidationV2', {
        method: 'POST',
        body: JSON.stringify(tppValidationPayload),
      });

      if (!tppValidationResponse) {
        setIsLoading(false);
        return;
      }

      let tppValidationResult = await tppValidationResponse.text();
      try {
        const parsed = JSON.parse(tppValidationResult);
        if (parsed?.error) {
          const details = parsed.error.details
            ? ` ${JSON.stringify(parsed.error.details)}`
            : '';
          tppValidationResult = `${parsed.error.message || 'Request failed'}${details}`;
        } else {
          tppValidationResult =
            parsed?.result ||
            parsed?.status ||
            parsed?.message ||
            parsed?.response ||
            tppValidationResult;
        }
      } catch {
        // response is plain text
      }

      const normalizedResult = String(tppValidationResult).trim();
      const isProceed =
        normalizedResult === 'proceed' ||
        normalizedResult === 'proceedToPayment';
      const isBlock =
        normalizedResult === 'block' ||
        normalizedResult === 'blockPayment';

      if (isBlock) {
        onBlocked?.();
        setIsLoading(false);
        return;
      }

      if (!isProceed) {
        console.error('Unexpected TPP validation response:', normalizedResult);
        setIsLoading(false);
        return;
      }
    } catch (error) {
      console.error('Error validating third-party payer:', error);
      setIsLoading(false);
      return;
    }

    const payflowPayload = {
      creditCardNbr: formObj.creditCardNbr,
      expirationDate: formObj.expirationDate,
      securityCode: formObj.securityCode,
      firstName: formObj.firstName || '',
      lastName: formObj.lastName || '',
      streetAddress1: formObj.billingStreetAddress1 || '',
      city: formObj.billingCity || '',
      stateProvince: formObj.billingStateProvince || '',
      postalCode: formObj.billingPostalCode || '',
      country: formObj.billingCountry || '',
      email: email || '',
    };

    for (const [index, order] of updatedOrders.entries()) {
    try {
      const response = await postData(`${protectedResources.apiPayer.queries.postorders}${order.orderNumber}`,
        JSON.stringify({
          ...payflowPayload,
          customersId: order.customersId,
          orderHeadersId: order.orderHeadersId,
          trxAmt: parseChargeAmount(order),
        }), {
          headers: {
            "Content-Type": "application/json",
          },
        });

     // Update the order with the API response
     updateOrderWithResponse(response, order, index, updatedOrders);
    } catch (error) {
      if (error.response && error.response.status < 500) {
        const responseData =  error.response;

     // Update the order with the API response
     updateOrderWithResponse(responseData, order, index, updatedOrders);

      }else{ 
      
        updatedOrders[index] = {
          ...order,
          status: 'Failed',
          message:  PAYMENT_FAILED_MESSAGE     
        }; 
    }
    }  
     
    }  
    setIsLoading(false);  
    handlePaySubmitClick();
  };

  const SubmitPayment = () => (
    <>
   
      <button type="submit" className={styles.button + " btn btn-primary"} disabled={isLoading || isAmountZero}>
        {isLoading ? 'Processing...' : 'Pay'}
      </button>
      <button type="button" onClick={handleCancel} className={styles.button + " btn btn-danger"}>
        Cancel
      </button>
    </>
  );

  const Message = ({ content, className }) => <p className={className}>{content}</p>;

  return (
    
      <div className={`${styles.form} payment-section`}>
        {isAmountZero ? (
          <p className={messageClass}>{message}</p>
        ) : (
          <> 
           <p>
            Total amount for {orders.length} selected application{orders.length === 1 ? "" : "s"} is <b>{toBePaid}</b>
          </p>  
            <h3 className={styles.heading}>Card Details</h3>
            <form id="form" className="form" onSubmit={submitHandler}>
              <div className="row">
                <div className="col-md-12">
                  <div className={`form-group ${cardNumberError ? 'errorField' : ''}`}>
                    <input
                      name="creditCardNbr"
                      type="text"
                      placeholder="Card Number"
                      className={`${styles.input} form-contorl`}
                      value={formatCardNumber(cardNumber)}
                      onChange={handleCardNumberChange}
                      maxLength="19"
                    />
                    {errors.cardNumber && <p className="small text-danger">{errors.cardNumber}</p>}
                    {cardType && (
                      <p className="small text-dark">
                        Card Type: {cardType.charAt(0).toUpperCase() + cardType.slice(1)}
                      </p>
                    )}
                    {cardNumberError && <p className="small text-danger">{cardNumberError}</p>}
                  </div>
                </div>
              </div>
    
              <div className="row">
                <div className="col-md-6">
                  <div className={`form-group ${expiryDateError ? 'errorField' : ''}`}>
                    <input
                      name="expirationDate"
                      type="text"
                      placeholder="Expiration Date: MM/YYYY"
                      className={`${styles.input} form-control`}
                      value={expiryDate}
                      onChange={handleExpiryDateChange}
                      maxLength="7"
                    />
                    {errors.expiryDate && <div className="small text-danger">{errors.expiryDate}</div>}
                    {expiryDateError && <p className="small text-danger">{expiryDateError}</p>}
                  </div>
                </div>
    
                <div className="col-md-6">
                  <div className={`form-group ${cvvError ? 'errorField' : ''}`}>
                    <input
                      name="securityCode"
                      maxLength={3}
                      type="text"
                      placeholder="CVV"
                      className={styles.input}
                      value={cvv}
                      onChange={handleCvvChange}
                    />
                    {cvvError && <p className="small text-danger">{cvvError}</p>}
                  </div>
                </div>
              </div>
    
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      name="firstName"
                      type="text"
                      placeholder="First Name on Card"
                      className={styles.input}
                      value={firstName}
                      onChange={handleFirstNameChange}
                      maxLength="30"
                    />
                    {errors.firstName && <p className="small text-danger">{errors.firstName}</p>}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      name="middleName"
                      type="text"
                      placeholder="Middle Name on Card"
                      className={styles.input}
                      value={middleName}
                      onChange={handleMiddleNameChange}
                      maxLength="30"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      name="lastName"
                      type="text"
                      placeholder="Last Name on Card"
                      className={styles.input}
                      value={lastName}
                      onChange={handleLastNameChange}
                      maxLength="30"
                    />
                    {errors.lastName && <p className="small text-danger">{errors.lastName}</p>}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <select
                      name="suffix"
                      className={styles.input}
                      value={suffix}
                      onChange={handleSuffixChange}
                    >
                      <option value="">Suffix</option>
                      <option value="II">II</option>
                      <option value="III">III</option>
                      <option value="IV">IV</option>
                      <option value="V">V</option>
                      <option value="JR.">JR.</option>
                      <option value="SR.">SR.</option>
                    </select>
                  </div>
                </div>
              </div>

              <p className={styles.sectionHeading}>Billing Address</p>
              <div className="row">
                <div className="col-md-12">
                  <input
                    name="billingStreetAddress1"
                    type="text"
                    placeholder="Street Address"
                    className={styles.input}
                    value={billingStreetAddress}
                    onChange={handleBillingStreetAddressChange}
                    maxLength="30"
                  />
                  {billingStreetAddressError && <p className="small text-danger">{billingStreetAddressError}</p>}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <select
                    name="billingCountry"
                    className={styles.input}
                    value={billingCountry}
                    onChange={handleBillingCountryChange}
                  >
                    <option value="">Select a Country</option>
                    {countries.map((countryItem) => (
                      <option key={`billing-${countryItem.paypalCountriesId}`} value={countryItem.countryName}>
                        {countryItem.countryName}
                      </option>
                    ))}
                  </select>
                  {billingCountryError && <p className="small text-danger">{billingCountryError}</p>}
                </div>

                <div className="col-md-6">
                  <input
                    name="billingCity"
                    type="text"
                    placeholder="City"
                    className={styles.input}
                    value={billingCity}
                    onChange={handleBillingCityChange}
                    maxLength="30"
                  />
                  {billingCityError && <p className="small text-danger">{billingCityError}</p>}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  {renderStateProvinceField({
                    name: 'billingStateProvince',
                    value: billingState,
                    onChange: handleBillingStateChange,
                    paymentCountry: billingCountry,
                    error: billingStateError,
                    keyPrefix: 'billing-state',
                  })}
                </div>

                <div className="col-md-6">
                  <input
                    name="billingPostalCode"
                    type="text"
                    placeholder="Postal Code"
                    className={styles.input}
                    value={billingPostalCode}
                    onChange={handleBillingPostalCodeChange}
                    maxLength={billingCountry === 'United States' ? 10 : 30}
                  />
                  {billingCountry === 'United States' && billingPostalCodeError && (
                    <p className="small text-danger">{billingPostalCodeError}</p>
                  )}
                </div>
              </div>

              <div className="form-group" style={{ display: 'flex', alignItems: 'center', margin: '8px 0 12px' }}>
                <input
                  type="checkbox"
                  id="billingSameAsMailing"
                  checked={billingSameAsMailing}
                  onChange={handleBillingSameAsMailingChange}
                  className="custom-checkbox"
                  style={{ width: '16px', height: '16px', marginRight: '8px' }}
                />
                <label htmlFor="billingSameAsMailing" className="small">
                  Check this if the Permanent Residence is same as the Billing Address
                </label>
              </div>

              {!billingSameAsMailing && (
                <>
                  <p className={styles.sectionHeading}>Permanent Residence</p>
                  <div className="row">
                    <div className="col-md-12">
                      <input
                        name="streetAddress1"
                        type="text"
                        placeholder="Street Address"
                        className={styles.input}
                        value={streetAddress}
                        onChange={handleStreetAddressChange}
                        maxLength="30"
                      />
                      {streetAddressError && <p className="small text-danger">{streetAddressError}</p>}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <select
                        name="country"
                        className={styles.input}
                        value={country}
                        onChange={handleCountryChange}
                      >
                        <option value="">Select a Country</option>
                        {countries.map((countryItem) => (
                          <option key={countryItem.paypalCountriesId} value={countryItem.countryName}>
                            {countryItem.countryName}
                          </option>
                        ))}
                      </select>
                      {countryError && <p className="small text-danger">{countryError}</p>}
                    </div>

                    <div className="col-md-6">
                      <input
                        name="city"
                        type="text"
                        placeholder="City"
                        className={styles.input}
                        value={city}
                        onChange={handleCityChange}
                        maxLength="30"
                      />
                      {cityError && <p className="small text-danger">{cityError}</p>}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      {renderStateProvinceField({
                        name: 'stateProvince',
                        value: state,
                        onChange: handleStateChange,
                        paymentCountry: country,
                        error: stateError,
                        keyPrefix: 'mailing-state',
                      })}
                    </div>

                    <div className="col-md-6">
                      <input
                        name="postalCode"
                        type="text"
                        placeholder="Postal Code"
                        className={styles.input}
                        value={postalCode}
                        onChange={handlePostalCodeChange}
                        maxLength={country === 'United States' ? 10 : 30}
                      />
                      {country === 'United States' && postalCodeError && (
                        <p className="small text-danger">{postalCodeError}</p>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="row">
                <div className="form-group refund-policy" style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    id="refundPolicy"
                    checked={isRefundPolicyChecked}
                    onChange={() => {
                      setIsRefundPolicyChecked(!isRefundPolicyChecked);
                      setMessage('');
                    }}
                    className="custom-checkbox"
                    style={{ width: '16px', height: '16px', marginRight: '8px' }}
                  />
                  <label htmlFor="refundPolicy" className="small" style={{ color: 'red' }}>
                    <span className="agree-text">I Agree</span> - By checking this checkbox, I agree and understand that TruMerit has a NO REFUND policy. No refund will be given after the payment is made.
                  </label>
                </div>
              </div>
    
              <div className="button-group button-group-margin-top">
             
                <SubmitPayment /> 
              </div>
            </form>
    
            {message && <Message content={message} className={messageClass} />}
            {declineErrorMsg && <Message content={declineErrorMsg} className={errorMessageClass} />}
            {isLoading && <Loader visible={true} />}
          </>
        )}
      </div>
    );
    
}

export default PayerForm;